<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">Add Account</p>
      </header>
      <section class="modal-card-body" style="height: 300px;">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <div class="control is-vertical">
          <div class="control is-grouped">
            <p class="control is-expanded">
              <label class="label">Customer</label>
              <v-select v-model="account.customer" :options="getCustomers()" class="is-fullwidth" max-height="200px"></v-select>
            </p>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a class="button is-primary" @click="close(true)">Cancel</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-disabled': errors.any() || inProgress || account.customer == null, 'is-loading': inProgress}" @click="add()">Add</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import Datepicker from 'vue-bulma-datepicker'
  import vSelect from 'vue-select'
  export default {
    props: {
      context: {
        type: Object
      },
      callback: {
        type: String
      }
    },
    data () {
      return {
        account: {
          customer: null
        },
        bases: [],
        agencies: [],
        inProgress: false,
        error: ''
      }
    },
    mounted () {
      this.$nextTick(() => {
        document.body.appendChild(this.$el)
        this.loadBases()
        this.loadCustomers()
      })
    },
    methods: {
      loadBases () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/bases/all').then((response) => {
          this.bases = response.body
        }, (response) => {
        })
      },
      loadCustomers () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/agencies/all').then((response) => {
          this.agencies = response.body
        }, (response) => {

        })
      },
      getCustomers () {
        let customers = []
        customers.push({label: 'All', value: ''})
        for (var i = 0; i < this.agencies.length; i++) {
          customers.push({label: this.agencies[i].name, value: this.agencies[i].id, type: 'agency'})
        }
        for (var x = 0; x < this.bases.length; x++) {
          customers.push({label: this.bases[x].name + ' (base)', value: this.bases[x].id, type: 'base'})
        }
        customers.sort(function (a, b) {
          if (a.label < b.label) {
            return -1
          }
          if (a.label > b.label) {
            return 1
          }
          return 0
        })
        return customers
      },
      parsePaymentMethod (method) {
        let methodName = ''
        if (parseInt(method.method_type) === 1) {
          methodName = 'CARD - ' + method.card_number + ' - ' + method.card_flag
        } else {
          methodName = 'BANK - ' + method.bank
          if (method.account !== null) {
            methodName = methodName + ' - ' + method.account
          }
          if (method.agency !== null) {
            methodName = methodName + ' - ' + method.agency
          }
        }
        return methodName
      },
      setCurrency (method) {
        this.currencies = this.credit.payment_method.currencies
      },
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      add () {
        this.inProgress = true
        this.error = ''
        if (window.confirm('Are you sure you want to create account')) {
          this.context.$http.post(this.context.$store.state.config.apiURL + '/account/create', this.account).then((response) => {
            this.inProgress = false
            this.close(false, 'ok')
          }, (response) => {
            this.inProgress = false
            this.error = response.body
          })
        } else {
          this.inProgress = false
        }
      }
    },
    components: {
      Datepicker,
      vSelect
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    }
  }
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// AccountAdd.vue?8920c2e6